<template>
  <v-container>
    <v-card width="100%" height="100%" elevation="0">
      <v-col cols="12" class="mt-3" :class="MobileSize ? 'px-0' : 'px-0 py-0'">
        <v-row class="mx-0" v-if="!MobileSize">
          <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;">E-Tax Credential</v-card-title>
        </v-row>
        <v-row v-else>
          <v-card-title style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;"><v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> E-Tax Credential</v-card-title>
        </v-row>
      </v-col>
      <v-card-title v-if="MobileSize" style="font-weight: 600; font-size: 18px; line-height: 26px;white-space: normal; display: inline-block; word-break:break-word;">ระบบ Sale Order สามารถสร้างใบกำกับภาษีได้อัตโนมัติ ผ่านระบบ E-Tax โดยเจ้าของร้านสามารถทำตามขั้นตอน ดังต่อไปนี้</v-card-title>
      <v-card-title v-else style="font-weight: 600; font-size: 18px; line-height: 26px;white-space: normal; display: inline-block; word-break:break-word;">ระบบ Sale Order สามารถสร้างใบกำกับภาษีได้อัตโนมัติ ผ่านระบบ E-Tax โดยเจ้าของร้านสามารถทำตามขั้นตอน ดังต่อไปนี้</v-card-title>
      <v-card-text>
        <v-timeline dense>
          <v-timeline-item fill-dot color="#E6E6E6" large>
            <template v-slot:icon>
              <!-- <v-avatar size="20"> -->
                <v-img src="@/assets/ImageINET-Marketplace/ICONShop/step_1.png" max-height="24" max-width="24" contain></v-img>
              <!-- </v-avatar> -->
            </template>
            <v-col cols="12" md="11">
              <span style="font-weight: 400; font-size: 16px; line-height: 24px; color: #333333;">1. สมัครกับบัญชีผู้ใช้กับ <a :href="pathURL === 'https://panit.one.th/' ? 'https://etax.one.th/portal/login' : 'https://devinet-etax.one.th/portal/login'" target="_blank" style="color: #1B5DD6; font-weight: bold; text-decoration: underline;">E-Tax</a></span>
            </v-col>
          </v-timeline-item>
          <v-timeline-item fill-dot color="#E6E6E6" large>
            <template v-slot:icon>
              <!-- <v-avatar size="20"> -->
              <v-img src="@/assets/ImageINET-Marketplace/ICONShop/step_2.png" max-height="24" max-width="24" contain></v-img>
              <!-- </v-avatar> -->
            </template>
            <v-col cols="12" md="11">
              <span style="font-weight: 400; font-size: 16px; line-height: 24px; color: #333333;">2. นำ User Code และ Access Key มากรอกที่ด้านล่าง</span>
            </v-col>
          </v-timeline-item>
          <v-timeline-item fill-dot color="#E6E6E6" large>
            <template v-slot:icon>
              <!-- <v-avatar size="20"> -->
              <v-img src="@/assets/ImageINET-Marketplace/ICONShop/step_3.png" max-height="24" max-width="24" contain></v-img>
              <!-- </v-avatar> -->
            </template>
            <v-col cols="12" md="11">
              <span style="font-weight: 400; font-size: 16px; line-height: 24px; color: #333333;">3. หลักจากนั้นเมื่อไหร่ก็ตามที่มีลูกค้าคำสั่งซื้อและจ่ายเงินสำเร็จ ใบกำกับภาษีจะถูกสร้างขึ้นในระบบ E-Tax</span>
            </v-col>
          </v-timeline-item>
        </v-timeline>
        <v-row dense justify="center" class="mt-6">
          <v-col cols="12" align="center">
            <v-row dense justify="center">
              <v-img src="@/assets/ImageINET-Marketplace/ICONShop/shop_1.png" contain max-height="57" max-width="57" :class="MobileSize ? 'mr-4 mt-1 mb-4' : 'mr-4 mt-1'"></v-img>
              <div class="pb-3" style="border-radius: 8px; background: #FBE5E4; min-height: 62px;" :style="IpadProSize || IpadSize  || MobileSize? 'width: 260px;' : 'width: 680px;'" v-if="CheckETaxCredential === false && CheckErrorCredential === false">
                <span :class="IpadProSize || IpadSize || MobileSize ? 'px-2' : ''" style="color: #F5222D; font-weight: 700; display: block; align-items: center; padding-top: 15px;" :style="IpadSize || MobileSize ? 'font-size: 14px; line-height: 22px;' : 'font-size: 18px; line-height: 30px;'">ร้านค้านี้ยังไม่ได้ยืนยัน User Code และ Access Key สำหรับต่อระบบ E-Tax</span>
              </div>
              <div class="pb-3" style="border-radius: 8px; background: rgba(82, 196, 26, 0.2); min-height: 62px;" :style="IpadProSize || IpadSize || MobileSize ? 'width: 260px;' : 'width: 680px;'" v-else-if="CheckETaxCredential === true && CheckErrorCredential === false">
                <span :class="IpadProSize || IpadSize || MobileSize? 'px-2' : ''" style="color: #52C41A; font-weight: 700; font-size: 20px; line-height: 30px; display: block; align-items: center; padding-top: 16px;" :style="IpadSize || MobileSize ? 'font-size: 14px; line-height: 22px;' : 'font-size: 18px; line-height: 30px;'">ร้านค้านี้ยืนยัน User Code และ Access Key สำหรับระบบ E-Tax แล้ว <v-icon color="#27AB9C">mdi-checkbox-marked-circle</v-icon></span>
              </div>
              <div class="pb-3" style="border-radius: 8px; background: #FBE5E4; min-height: 62px;" :style="IpadProSize || IpadSize || MobileSize ? 'width: 260px;' : 'width: 740px;'" v-else-if="(CheckETaxCredential === true || CheckETaxCredential === false) && CheckErrorCredential === true">
                <span :class="IpadProSize || IpadSize || MobileSize ? 'px-2' : ''" style="color: #F5222D; font-weight: 700; font-size: 20px; line-height: 30px; display: block; align-items: center; padding-top: 15px;" :style="IpadSize || MobileSize ? 'font-size: 14px; line-height: 22px;' : 'font-size: 18px; line-height: 30px;'">ข้อมูล E-Tax Credentials ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง</span>
              </div>
            </v-row>
          </v-col>
        </v-row>
        <v-row dense justify="center" class="mt-8">
          <v-col cols="12" align="center">
            <v-form ref="formETax" :lazy-validation="lazy">
              <v-card elevation="0" style="background: #EBEBEB; border: 1px solid #EBEBEB; border-radius: 8px;" width="416" height="100%">
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12">
                      <div style="border: 2px solid #5BC3A2; border-radius: 8px; background: #FFFFFF; height: 62px;">
                        <span style="font-weight: 700; font-size: 20px; line-height: 30px; color: #333333; display: block; align-items: center; padding-top: 14px;">Tax ID : {{ taxID }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" align="start" class="mt-4">
                      <span style="font-weight: 400; font-size: 16px; line-height: 24px; color: #333333;">Document Type <span style="color: red;">*</span></span>
                      <v-select v-model="selectDocumentType" class="input_text" :items="documentTypeList" item-value="code" item-text="name" outlined dense placeholder="ระบุ Document Type" :rules="Rules.documentType" hide-details></v-select>
                    </v-col>
                    <v-col cols="12" align="start">
                      <span style="font-weight: 400; font-size: 16px; line-height: 24px; color: #333333;">Access Token <span style="color: red;">*</span></span>
                      <v-text-field v-model="accessToken" class="input_text" placeholder="ระบุ Access Token" outlined dense :rules="Rules.accessToken"></v-text-field>
                    </v-col>
                    <v-col cols="12" align="start">
                      <span style="font-weight: 400; font-size: 16px; line-height: 24px; color: #333333;">User Code <span style="color: red;">*</span></span>
                      <v-text-field v-model="userCode" class="input_text" placeholder="ระบุ User Code" outlined dense :rules="Rules.usercode"></v-text-field>
                    </v-col>
                    <v-col cols="12" align="start">
                      <span style="font-weight: 400; font-size: 16px; line-height: 24px; color: #333333;">Access Key <span style="color: red;">*</span></span>
                      <v-text-field v-model="accessKey" class="input_text" placeholder="ระบุ Access Key" autocomplete="new-password" type="password" outlined dense :rules="Rules.AccessKey"></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="mb-4">
                  <v-row justify="end" dense>
                    <v-btn color="#27AB9C" outlined class="px-7 mr-2" @click="cancel()">ยกเลิก</v-btn>
                    <v-btn color="#27AB9C" class="white--text px-8 mr-2" @click="confirm()">ยืนยัน</v-btn>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-10 mb-4">
          <v-col cols="12" :align="MobileSize ? 'start' : 'center'">
            <span style="font-size: 16px; line-height: 26px; color: #333333;"><b>หมายเหตุ</b> : ถ้าต้องการจะเปลี่ยน User Code หรือ Access Key คุณสามารถกลับมายืนยัน User Code และ Access Key ใหม่ในหน้านี้ได้</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      taxID: '',
      lazy: false,
      CheckETaxCredential: false,
      CheckErrorCredential: false,
      accessKey: '',
      userCode: '',
      accessToken: '',
      onedata: [],
      sellerTaxID: '',
      pathURL: process.env.VUE_APP_DOMAIN,
      Rules: {
        documentType: [
          v => !!v || 'กรุณากรอก Document Type'
        ],
        AccessKey: [
          v => !!v || 'กรุณากรอก Access Key'
        ],
        usercode: [
          v => !!v || 'กรุณากรอก User Code'
        ],
        accessToken: [
          v => !!v || 'กรุณากรอก Access Token'
        ]
      },
      userDetailSelling: '',
      selectDocumentType: '',
      documentTypeList: []
    }
  },
  async created () {
    window.addEventListener('storage', function (event) {
      if (event.key === 'oneData' && !event.newValue) {
        window.location.assign('/')
      }
    })
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    }
    if (localStorage.getItem('UserDetailSelling') !== null) {
      this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
    }
    this.onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    await this.checkShopTaxID()
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push({ path: '/Order/EtaxCredentialMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/EtaxCredential' }).catch(() => {})
      }
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    async checkShopTaxID () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      var data = {
        seller_shop_id: shopData.seller_shop_id
      }
      await this.$store.dispatch('actionsSaleOrderDetailSettingEtax', data)
      // console.log(data)
      var responseData = await this.$store.state.ModuleSaleOrderEtax.stateSaleOrderDetailSettingEtax
      if (responseData.result === 'SUCCESS') {
        this.$store.commit('closeLoader')
        // console.log(responseData)
        this.documentTypeList = responseData.data.document_list
        this.selectDocumentType = responseData.data.document_type.length === 0 ? '' : responseData.data.document_type[0].code
        this.taxID = responseData.data.tax_id
        this.sellerTaxID = responseData.data.tax_id
        this.checkShopEtax()
      } else {
        this.$store.commit('closeLoader')
        if (responseData.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (responseData.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(responseData.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async checkShopEtax () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      var data = {
        seller_shop_taxID: this.sellerTaxID,
        seller_shop_id: shopData.seller_shop_id
      }
      // console.log('data to check shop', data)
      await this.$store.dispatch('actionsSaleOrderCheckETaxInShop', data)
      var response = await this.$store.state.ModuleSaleOrderEtax.stateSaleOrderCheckETaxInShop
      // console.log('response =============>', response)
      if (response.message === 'Check shop E-tax credentials exist successfully.') {
        this.$store.commit('closeLoader')
        if (response.data === 'yes') {
          this.CheckETaxCredential = true
          this.CheckErrorCredential = false
        } else {
          this.CheckETaxCredential = false
          this.CheckErrorCredential = false
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    cancel () {
      this.resetData()
    },
    resetData () {
      this.accessToken = ''
      this.userCode = ''
      this.accessKey = ''
      this.$refs.formETax.reset()
      this.$refs.formETax.resetValidation()
    },
    async confirm () {
      this.$store.commit('openLoader')
      const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
      if (this.$refs.formETax.validate(true)) {
        var shopData = this.userDetailSelling
        var data = {
          document_type: this.selectDocumentType,
          seller_shop_taxID: this.sellerTaxID,
          seller_shop_id: shopData.seller_shop_id,
          UserCode: this.userCode,
          AccessKey: this.accessKey,
          access_token: this.accessToken,
          token: oneData.user.access_token
        }
        await this.$store.dispatch('actionsSaleOrderSendAccessETax', data)
        var response = await this.$store.state.ModuleSaleOrderEtax.stateSaleOrderSendAccessETax
        if (response.message === 'set e-tax credential success') {
          this.$store.commit('closeLoader')
          this.CheckETaxCredential = true
          this.CheckErrorCredential = false
          this.resetData()
          this.checkShopTaxID()
          this.$swal.fire({ icon: 'success', text: 'เชื่อมต่อกับระบบ E-Tax สำเร็จ', showConfirmButton: false, timer: 2000 })
        } else {
          this.$store.commit('closeLoader')
          this.CheckETaxCredential = false
          this.CheckErrorCredential = true
          if (response.message === 'This user is unauthorized.') {
            this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else if (response.message === 'Not access this function.') {
            this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
            window.location.assign('/')
          } else {
            var [msg, iconMsg] = this.getErrorMsg(response.message)
            this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
          }
          // this.$swal.fire({ icon: 'error', title: 'เจอข้อผิดพลาดในระบบ Sale Order ในส่วน Credentials ของ E-Tax โปรดติดต่อเจ้าหน้าที่ Sale Order', showConfirmButton: false, timer: 2500 })
        }
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
      }
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Data missing. Please check your parameter and try again.') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Seller shop not found.' || msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Parameter Missing. Please check and try again.') {
        return ['ข้อมูลขาดหาย โปรดลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else if (msg === 'Employee not found.') {
        return ['ไม่พบพนักงาน', 'warning']
      } else if (msg === 'Customer in this shop not found.') {
        return ['ไม่พบลูกค้าในร้านนี้', 'warning']
      } else if (msg === 'Bad Authorization in Header') {
        return ['ข้อมูล E-Tax Credentials ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Please check your access_token.') {
        return ['Access Token ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Password ของ Certificate ไม่ถูกต้อง') {
        return ['Password ของ Certificate ไม่ถูกต้อง', 'warning']
      } else if (msg === 'เลขประจำตัวผู้เสียภาษีอากรที่ระบุ  ไม่ตรงกับข้อมูลใน CSV-Text') {
        return ['เลขประจำตัวผู้เสียภาษีอากรที่ระบุ ไม่ตรงกับข้อมูลใน CSV-Text', 'warning']
      } else if (msg === 'รหัสผู้ใช้งาน ไม่ได้ลงทะเบียนไว้ในระบบ') {
        return ['รหัสผู้ใช้งาน ไม่ได้ลงทะเบียนไว้ในระบบ', 'warning']
      } else {
        return [msg, 'error']
      }
    }
  }
}
</script>

<style>
  .input_text {
    height: 60px;
    opacity: 1 !important;
  }
  #txtPassword{
    -webkit-text-security:disc;
  }
</style>
<style scoped>
::v-deep .v-select.v-input--dense .v-select__selection--comma {
  padding: 2px;
}
::v-deep .v-list-item__title {
  padding: 6px;
}
</style>
